<script>

    import { toast } from 'bulma-toast'

    import FixedpricesService from '../$services/fixedprices.service'

    import Button from '../$components/button.svelte'

    let loading = false
    let element = null

    async function getFixedpricesReport() {

        loading = true
        const blob = await FixedpricesService.getFixedpricesReport()
        loading = false

        if(!blob)
            return toast({message: 'Error al descargar el archivo', type: 'is-danger'})

        const fileName = `Precios_fijos_reporte`

        element.download = `${fileName}.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<Button on:click={ getFixedpricesReport } text="Descargar" icon="download" { loading } />